/* RESPONSIBLE TEAM: team-frontend-tech */
import { attr } from '@ember-data/model';
import Block from './block';

export default Block.extend({
  imageUrl: attr('string'),
  text: attr('string'),
  title: attr('string'),
});
